import { Form, Input, ModalProps, FormProps, Modal, Select, InputNumber, useSelect, message, Button, Typography } from '@pankod/refine-antd'
import { useGetIdentity, useCreate, useMutationMode, useNavigation } from '@pankod/refine-core'
import { IUser } from 'interfaces'
import React, { useEffect, useState } from 'react'
import { nhost } from 'utility'
import { getAllRoles, createUser } from 'users'
import { useUserContext } from 'context/user'
type CreateUserProps = {
  modalProps: ModalProps
  formProps: FormProps
  close: any
  refreshData: any
}
export interface ISignup {
  email: string
  password: string
  displayName: string
  defaultRole: string
  roles: string[]
  created_by: string
}
export const UserCreate: React.FC<CreateUserProps> = ({ modalProps, formProps, close, refreshData }) => {
  const { data: user } = useGetIdentity()
  const { userRole } = useUserContext()
  const [form] = Form.useForm<ISignup>()
  const [reload, setReload] = useState(false)
  const { push, goBack } = useNavigation()
  const [roleList, setRoleList] = useState([] as any[])
  const [selectedRoles, setSelectedRoles] = useState<string[]>()
  const [open, setOpen] = useState(true)
  let sic_roles = ['qcreator', 'qreviewer', 'qapprover', 'variantcreator']
  let pm_roles = ['qcreator', 'qreviewer', 'qapprover', 'variantcreator', 'subjectincharge', 'papersetter', 'paperapprover']

  useEffect(() => {
    getAllRoles().then((response: any) => {
      setRoleList(response.authRoles)
    })
    formProps?.form?.resetFields()
  }, [])

  const success = (msg: string, type: string) => {
    // refreshData()
    if (type === 'success') {
      message.success(msg)
      formProps?.form?.resetFields()
      close()
    } else {
      formProps?.form?.setFieldsValue({
        email: null,
      })
      message.error(msg)
    }
  }
  const handleRoleChange = (value: string[]) => {
    setSelectedRoles(value)
    console.log('selrcyed', selectedRoles)
    // setOpen(false)
  }

  //   const { mutate: createUser } = useCreate<IUser>();
  return (
    <Modal
      {...modalProps}
      title="Create User"
      onCancel={() => {
        formProps?.form?.resetFields()
        close()
      }}
    >
      <Form
        form={form}
        {...formProps}
        size="large"
        layout="vertical"
        onFinish={values => {
          console.log('values', values)
          let user_values: ISignup

          if (values?.roles?.includes('admin')) {
            user_values = {
              displayName: values?.displayName,
              roles: ['admin'],
              defaultRole: 'admin',
              email: values?.email,
              password: values?.password,
              created_by: values?.created_by,
            }
          } else {
            user_values = values
          }
          createUser(user_values).then(response => {
            if (response === 'OK') {
              success('A link has been sent to the email address for the user to verify', 'success')
              formProps?.form?.resetFields()
              refreshData()
            } else {
              success(response, 'danger')
            }
          })
        }}
      >
        <Form.Item
          label="Display Name"
          name="displayName"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Role" name="roles" rules={[{ required: true }]}>
          <Select
            mode="multiple"
            onChange={handleRoleChange}
            open={open}
            onDropdownVisibleChange={visible => setOpen(visible)}
            dropdownRender={menu => (
              <div>
                {menu}

                <Button size="small" type="primary" onClick={() => setOpen(false)} style={{ position: 'absolute', right: 10, top: 5 }}>
                  Close
                </Button>
              </div>
            )}
          >
            {roleList.length > 0 &&
              roleList?.map(item =>
                userRole === 'subjectincharge' ? (
                  sic_roles.includes(item?.role) ? (
                    <option key={item?.role} value={item?.role}>
                      {item?.role}
                    </option>
                  ) : null
                ) :
                  userRole === 'productmanager' ? (
                    pm_roles.includes(item?.role) ? (
                      <option key={item?.role} value={item?.role}>
                        {item?.role}
                      </option>
                    ) : null
                  )


                    : (
                      item?.role !== 'user' &&
                      item?.role !== 'me' && (
                        <option key={item?.role} value={item?.role}>
                          {item?.role}
                        </option>
                      )
                    )
              )}
          </Select>
        </Form.Item>
        <Form.Item label="Primary Role" name="defaultRole" rules={[{ required: selectedRoles?.includes('admin') ? false : true }]}>
          <Select disabled={selectedRoles?.includes('admin')}>
            {selectedRoles?.map((item: any) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </Select>
        </Form.Item>
        {selectedRoles?.includes('admin') === true ? (
          <Typography.Text type="warning">Admin has all permissions. No need to select multiple roles</Typography.Text>
        ) : null}
        <Form.Item
          label="Email"
          name="email"
          rules={[
            {
              required: true,
              type: 'email',
            },
          ]}
        >
          <Input placeholder="Email" />
        </Form.Item>
        <Form.Item
          label="Password"
          name="password"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input.Password placeholder="input password" />
        </Form.Item>

        <Form.Item name="created_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
